import React from 'react';

function MailIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" style={{ fill: '#1abc9c' }}>
      <path d="M12 12.713l-11.985-9.713h23.97l-11.985 9.713zm0 2.574l-12-9.725v15.438h24v-15.438l-12 9.725z"/>
    </svg>
  )
}

export default MailIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/MailIcon.js